import { createSelector } from 'reselect';

const getMoments = state => {
  return state.cartReducer.moments;
}

const getMomentIds = state => {
  return state.cartReducer.moments.allIds;
}

const getSelectedMomentIds = state => {
  return state.cartReducer.selectedMomentIds;
}

const getSelectedPrintMomentIds = state => {
  return state.cartReducer.selectedPrintMomentIds;
}

const getCalculations = state => {
  return state.cartReducer.calculations;
}

export const getCombinedSelectedMomentIds = createSelector(
  getSelectedMomentIds,
  getSelectedPrintMomentIds,
  getMomentIds,
  (selectedMomentIds, selectedPrintMomentIds, momentIds) => {
    let combined = selectedMomentIds
      .concat(selectedPrintMomentIds)
      .filter(id => momentIds.indexOf(id) !== -1);

    return combined.filter((val, index) => {
      return combined.indexOf(val) === index;
    });
  }
);

export const getSelectedCount = createSelector(
  getCombinedSelectedMomentIds,
  selectedMomentIds => selectedMomentIds.length
);

export const getSelectedMoments = createSelector(
  getCombinedSelectedMomentIds,
  getMoments,
  (selectedMomentIds, moments) => {
    return selectedMomentIds.map(id => moments.byId[id]);
  }
);

export const getSelectedPrintMoments = createSelector(
  getSelectedPrintMomentIds,
  getMoments,
  (selectedPrintMomentIds, moments) => {
    return selectedPrintMomentIds.map(id => moments.byId[id]);
  }
);

export const getSelectedCalculations = createSelector(
  getCalculations,
  getSelectedMomentIds,
  (calculations, selectedMomentIds) => {
    let calcs = calculations.by_quantity.find(calcs => {
      return calcs.quantity === selectedMomentIds.length;
    });
    return  calcs && calcs.details;
  }
);

export const getCartMoments = createSelector(
  getMoments,
  moments => moments.allIds.map(id => moments.byId[id])
);

export const getAvailableMomentIds = createSelector(
  getCartMoments,
  moments => {
    return moments.filter(m => !m.purchased).map(m => m.id);
  }
);

export const getAvailableMoments = createSelector(
  getCartMoments,
  moments => {
    return moments.filter(m => !m.purchased);
  }
);